import { IEmployeeExperienceContext } from '@micro-frontend-react/employee-experience/lib/IEmployeeExperienceContext';
import { useContext, useEffect, useState, Context as ReactContext } from 'react';
import { Context } from '@micro-frontend-react/employee-experience/lib/Context';
import { DataOwnerRecord } from '../../Common/DataOwnerModels/DataOwnerRecord';

export function useGetDataOwnersForHome() {
  const [dataOwnerList, setDataOwnerList] = useState<DataOwnerRecord[]>([]);
  const [dataOwnerListLoading, setDataOwnerListLoading] = useState<boolean>(true);
  const { httpClient } = useContext(Context as ReactContext<IEmployeeExperienceContext>);

  useEffect(() => {
    setDataOwnerListLoading(true);
    httpClient
      .get<DataOwnerRecord[]>(`${__API_BASE_URL__}/tenant/getAllTenants`, {
        resource: __CLIENT_ID__,
        headers: {
          'Content-Type': 'application/json',
          'X-Content-Type-Options': 'nosniff',
        },
      })
      .then(({ data }) => {
        // Limit to Three Data Owners shown on the Home Page
        const newDataownerList = (data as DataOwnerRecord[]).slice(0, 3);
        setDataOwnerList(newDataownerList);
        setDataOwnerListLoading(false);
      });
  }, []);

  return [dataOwnerList, dataOwnerListLoading] as const;
}
